module.exports = __webpack_public_path__ + "static/media/08.025f9aa4.jpg";